var map = {
	"./1a_1280.png": 2017,
	"./1a_1920.png": 6797,
	"./1a_640.png": 7409,
	"./1b_1280.png": 6615,
	"./1b_1920.png": 876,
	"./1b_640.png": 8493,
	"./1c_1280.png": 8518,
	"./1c_1920.png": 194,
	"./1c_640.png": 508,
	"./2a_1280.png": 7171,
	"./2a_1920.png": 8338,
	"./2a_640.png": 9952,
	"./2b_1280.png": 6914,
	"./2b_1920.png": 2498,
	"./2b_640.png": 8030,
	"./2c_1280.png": 4509,
	"./2c_1920.png": 3123,
	"./2c_640.png": 7976,
	"assets/basilisktower/1a_1280.png": 2017,
	"assets/basilisktower/1a_1920.png": 6797,
	"assets/basilisktower/1a_640.png": 7409,
	"assets/basilisktower/1b_1280.png": 6615,
	"assets/basilisktower/1b_1920.png": 876,
	"assets/basilisktower/1b_640.png": 8493,
	"assets/basilisktower/1c_1280.png": 8518,
	"assets/basilisktower/1c_1920.png": 194,
	"assets/basilisktower/1c_640.png": 508,
	"assets/basilisktower/2a_1280.png": 7171,
	"assets/basilisktower/2a_1920.png": 8338,
	"assets/basilisktower/2a_640.png": 9952,
	"assets/basilisktower/2b_1280.png": 6914,
	"assets/basilisktower/2b_1920.png": 2498,
	"assets/basilisktower/2b_640.png": 8030,
	"assets/basilisktower/2c_1280.png": 4509,
	"assets/basilisktower/2c_1920.png": 3123,
	"assets/basilisktower/2c_640.png": 7976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4618;